import React, { useEffect, useState } from 'react';

import HeaderComponent from '../../common-components/HeaderComponent/HeaderComponent';

import './styles/main-page.scss';

import { ControlPoint as ControlPointIcon } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';

import Breadcrumb, { BreadCrumbSeparator } from '@/components/common-components/Breadcrumb/Breadcrumb';

import { fetchPostTrackingLibraries } from '../../../redux/socialListening/socialListeningActions';
import MainFallbackLoader from '../../common-components/Loaders/MainFallbackloader';
import { OutlinedButton } from '../../styledComponents';
import PaginationComponent from '../components/PaginationComponent';
import CreateEditLibraryModal from './components/Library/CreateEditLibraryModal';
import LibraryFtux from './components/Library/LibraryFtux';
import LibraryItem from './components/Library/LibraryItem';
import SocialListeningHeader from './components/SocialListeningHeader';

const SocialListeningLibraries = () => {
  const {
    isLoadingLibraries,
    libraries: libraryCache,
    totalLibraryPages,
  } = useSelector((state) => state.socialListening);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const key = `${currentPage}-9`;
  const libraries = libraryCache[key] || [];
  const pageCount = totalLibraryPages[key] || 0;
  const [isCreateLibraryOpen, setIsCreateLibraryOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchPostTrackingLibraries());
  }, []);

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    if (libraryCache[`${newPage}-9`]) return;
    dispatch(fetchPostTrackingLibraries(newPage));
  };

  const getContent = () => {
    if (isLoadingLibraries) return <MainFallbackLoader />;
    if (libraries.length === 0) return <LibraryFtux />;

    return (
      <>
        <div className="sl-libraries-container">
          {libraries.map((library) => (
            <LibraryItem key={library._id} library={library} />
          ))}
        </div>
        {pageCount > 1 && (
          <PaginationComponent
            totalPages={pageCount}
            currentPage={currentPage}
            setCurrentPage={onPageChange}
            className="sl-libraries-pagination"
          />
        )}
      </>
    );
  };

  return (
    <div className="sl-main-container">
      <HeaderComponent
        title={<SocialListeningLibrariesHeader />}
        showSearchBar={false}
        rightSection={
          libraries.length > 0 && (
            <div className="header-button-container ">
              <OutlinedButton
                onClick={() => setIsCreateLibraryOpen(true)}
                style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <ControlPointIcon /> Create New Library
              </OutlinedButton>
            </div>
          )
        }
        style={{ position: 'sticky', top: 0 }}
      />
      <div className="w-full max-screen-profile-view lists-view" style={{ height: 'calc(100vh - 82px)' }}>
        <SocialListeningHeader />
        <div className="sl-content-container">{getContent()}</div>
        {isCreateLibraryOpen && (
          <CreateEditLibraryModal show={isCreateLibraryOpen} onClose={() => setIsCreateLibraryOpen(false)} />
        )}
      </div>
    </div>
  );
};

export default SocialListeningLibraries;

function SocialListeningLibrariesHeader() {
  return (
    <div className="sl-breadcrumb-wrapper">
      <Breadcrumb className="sl-page-header-text">PULSE</Breadcrumb>
      <BreadCrumbSeparator />
      <Breadcrumb active> Libraries</Breadcrumb>
    </div>
  );
}
